module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/cf81254aea661228ff37115c73e81d47.svg";